import { useLocale as e } from "../hooks/useLocale.mjs";
import { useTranslateConfig as t } from "../I18nProvider.mjs";
import { hashText as n } from "./hashText.mjs";
import { useCallback as r, useState as i } from "react";
import { useQuery as a } from "@maat/store-hooks";
//#region src/translate/useTextTranslation.ts
var o = "https://translation.googleapis.com/language/translate/v2";
async function s(e, t, n) {
	let r = await fetch(`${o}?key=${encodeURIComponent(e)}`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			q: [t],
			target: n,
			format: "text"
		})
	});
	if (!r.ok) throw Error(`Translation request failed (${r.status})`);
	let i = (await r.json()).data?.translations?.[0];
	if (!i?.translatedText) throw Error("Translation response was empty");
	return {
		translatedText: i.translatedText,
		detectedSourceLanguage: i.detectedSourceLanguage
	};
}
var c = (o) => {
	let { translateApiKey: c } = t(), { locale: l } = e(), [u, d] = i(!1), f = !!(c && o && o.trim() !== ""), p = a({
		queryKey: [
			"text-translation",
			l,
			n(o ?? "")
		],
		queryFn: () => s(c, o, l),
		enabled: u && f,
		staleTime: Infinity,
		gcTime: 1440 * 60 * 1e3,
		retry: 1
	}), m = r(() => d((e) => !e), []), h = p.data?.detectedSourceLanguage?.toLowerCase().split("-")[0];
	return {
		translatedText: u ? p.data?.translatedText : void 0,
		isLoading: u && p.isLoading,
		error: p.error ?? void 0,
		canTranslate: f,
		showTranslation: u,
		toggle: m,
		isSameLanguage: h !== void 0 && h === l
	};
};
//#endregion
export { c as useTextTranslation };
